import React, { useEffect, useState } from 'react'
import { component } from "picoapp";
import { createRoot } from "react-dom/client";



function WalliBundle() {
  const [selectedCase, setSelectedCase] = useState();
  const [selectedCaseVariant, setSelectedCaseVariant] = useState();
  const [selectedJug, setSelectedJug] = useState();
  const [bundleProducts, setBundleProducts] = useState([]);
  const [shakerProducts, setShakerProducts] = useState([]);
  const [currentStep, setCurrentStep] = useState(1)
  const [totalPrice, setTotalPrice] = useState(0)

  const resetState = () => {
    setBundleProducts([]);
    setShakerProducts([]);
    setCurrentStep(1)
    setTotalPrice(1);
  }

  useEffect(() => {
    console.log("selCase:", selectedCase, "selJug:", selectedJug, "selVar:", selectedCaseVariant);
      let sum = 0;
      if (selectedJug && selectedCase) {
        sum = Number(selectedJug.variants[0].price) + Number(selectedCaseVariant.price);
      }
      sum = Math.round((sum + Number.EPSILON) * 100) / 100
      setTotalPrice(sum);
  },[selectedJug, selectedCaseVariant])

  const handleProductAdd = (product) => {
    if (product.vendor.includes("Hydro")) {
      setSelectedJug(product)
    } else {
      setSelectedCase(product);
      setSelectedCaseVariant(product.variants[0]);
    }
  }
  const handleProductDelete = (product) => {
    if (product.vendor.includes("Hydro")) {
      setSelectedJug({})
    } else {
      setSelectedCase({});
    }
  }
  function addToCart() {
    let body = {
      items: []
    }
    body.items = [
      {
        id: selectedJug.variants[0].id,
        quantity: 1
      },
      {
        id: selectedCaseVariant.id,
        quantity: 1
      }
    ]

    fetch("/cart/add.js", {
      "method": "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
    .then(res => {
      res.json().then(res => {
        console.log("added", res);
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.querySelector("cart-drawer").show();
      })
    })
    .catch(err => {
      console.log("couldn't add", err);
    })
  
    function addToCartItem(item, callback, retries = 3) {
      if (retries < 0) {
        console.error('Failed to add item to the cart after multiple attempts.', item);
        callback();
        return;
      }
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { id: item.id, quantity: item.quantity },
        success: function(data) {
          console.info('Successfully added item to the cart', data);
          callback();
        },
        error: function(error) {
          console.error('Error adding item to the cart, retrying...', error);
          setTimeout(() => addToCartItem(item, callback, retries - 1), 1000); // Retry after 1 second
        }
      });
    }
  
    // function addItemsSequentially(index) {
    //   if (index >= items.length) {
    //     setTimeout(() => {
    //       window.location.href = '/checkout';
    //     }, 2000); // Set a timeout before redirecting to checkout
    //     return;
    //   }
  
    //   addToCartItem(items[index], () => addItemsSequentially(index + 1));
    // }
  
    // addItemsSequentially(0);
  }
  useEffect(()=> {
    const fetchProducts = async () => {
      try {
        const bundleResponse = await fetch(`/collections/walli-collab-bottles/products.json`, {
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Access-Token': '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',
          },
        });
        const shakerResponse = await fetch(`/collections/walli-cases/products.json`, {
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Access-Token': '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',
          },
        });
        
        const bundleResult = await bundleResponse.json();
        const shakerResult = await shakerResponse.json();
        console.log("resps:", bundleResult, shakerResult);
        const bundleCollection = bundleResult;
        const shakerCollection = shakerResult;
        bundleCollection.products = bundleCollection.products.filter(prod => {
          const filteredVariants = prod.variants.filter(variant => variant.available && (!variant.title.includes("presale") && !variant.title.includes("pre-sale") && !variant.title.includes("Pre-sale") && !variant.title.includes("Presale") && !variant.title.includes("Pre-Sale")))
          prod.variants = filteredVariants;
          return prod.variants.length > 0;
        })
        shakerCollection.products = shakerCollection.products.filter(prod => {
          const filteredVariants = prod.variants.filter(variant => variant.available && (!variant.title.includes("presale") && !variant.title.includes("pre-sale") && !variant.title.includes("Pre-sale") && !variant.title.includes("Presale") && !variant.title.includes("Pre-Sale")))
          prod.variants = filteredVariants;
          return prod.variants.length > 0;
        })
        setBundleProducts(bundleCollection.products)
        setShakerProducts(shakerCollection.products)
      } catch (error) {
        console.log("errror", error)
      } 
    }
    fetchProducts();
  },[])
  return (
    <div id="product-card" className="product-card">
  <h2 id="step-title">Build your Hydrojug x Walli Bundle</h2>
  <div className="easterBundleContainer">
    <div id="carousel" className="carousel">
      <div className="carousel-inner" id="bundle-carousel">
        {bundleProducts.map((product, i) => (
          <div className={`carousel-item ${(selectedJug?.id === product.id) && "active"}`} key={i} onClick={() => {
            handleProductAdd(product)
            setCurrentStep(2);
            }} data-id={`${ product.variants[0]?.id }`} data-title={`${ product.title }`} data-price={`${ product.price }`} data-image={`${ product.images[0]?.src }`}>
            <img src={`${ product.images[0]?.src }`} alt={`${ product.title }`}/>
            <p>{ product.title }</p>
            <p className="price">{ product.price }</p>
            <div className="checkSvg-container" 
            >
                <div className='checkSvg checkmark-animation'>
                  <span className="order-badge">1st<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle cx="26" cy="26" r="25" fill="none"/><path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span> 
                </div>
            </div>
          </div>
        ))}
      </div>
      <div className="carousel-inner" id="shaker-carousel">
        {shakerProducts.map((product, i) => (
          <div className={`carousel-item ${(selectedCase?.id === product.id) && "active"}`} key={i} onClick={() => handleProductAdd(product)} data-id={`${ product.variants[0]?.id }`} data-title={`${ product.title }`} data-price={`${ product.price }`} data-image={`${ product.images[0]?.src }`}>
            <img src={`${ product.images[0]?.src }`} alt={`${ product.title }`}/>
            <p>{ product.title }</p>
            <p className="price">{ product.price }</p>
            <div className="checkSvg-container" 
            >
              <div className='checkSvg checkmark-animation'>
                <span className="order-badge">2nd<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle cx="26" cy="26" r="25" fill="none"/><path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span> 
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="carousel-inner">
        {selectedCase?.variants?.map((variant, i) => (
          <div className={`carousel-item ${(selectedCaseVariant.id === variant.id) && "active"}`} key={i} onClick={() => setSelectedCaseVariant(variant)}>
            {/* <img src={`${ variant.images[0]?.src }`} alt={`${ variant.title }`}/> */}
            <p>{ variant.title }</p>
            <p className="price">{ variant.price }</p>
            <div className="checkSvg-container" 
            >
              <div className='checkSvg checkmark-animation'>
                <span className="order-badge"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle cx="26" cy="26" r="25" fill="none"/><path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span> 
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div id="summary-container">
      <div id="summary" className="summary">
        <div className="summary-step" id="summary1">
          {selectedJug && <img id="summaryImg1" src={selectedJug?.images[0]?.src} alt="Product Image"/>}
          <div className="summary-content">
            <p id="summaryTitle1">{selectedJug ? selectedJug.title : "Step 1: Please Select A Hydrojug"}</p>
            {selectedJug && <p id="summaryPrice1">{selectedJug?.variants[0].price}</p>}
            <p id="summaryPrice1"></p>
          </div>
          <svg className="remove-button" onClick={() => {
            handleProductDelete(selectedJug);
            setCurrentStep(1)
            }} id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.93 120">
            <defs>
            </defs>
            <g id="Layer_2-2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1-2">
                <g>
                  <path className="cls-1" d="M82.28,9.12h-24.7v-2.46c0-3.67-2.95-6.66-6.58-6.66h-13.08c-3.63,0-6.58,2.99-6.58,6.66v2.46H6.65c-3.66,0-6.65,2.96-6.65,6.59v4.35c0,2.73,1.68,5.08,4.08,6.08.76,15.09,5.14,88.07,5.34,91.35.08,1.41,1.25,2.51,2.66,2.51h64.77c1.41,0,2.58-1.1,2.66-2.51.2-3.28,4.58-76.26,5.34-91.35,2.39-1,4.08-3.35,4.08-6.08v-4.35c0-3.63-2.98-6.59-6.65-6.59ZM36.68,6.66c0-.73.56-1.32,1.24-1.32h13.08c.69,0,1.24.59,1.24,1.32v2.46h-15.57v-2.46h0ZM5.33,15.71c0-.69.59-1.26,1.31-1.26h75.64c.72,0,1.31.56,1.31,1.26v4.35c0,.69-.59,1.26-1.31,1.26H6.65c-.72,0-1.31-.56-1.31-1.26v-4.35h-.01ZM74.34,114.67H14.59c-.78-13.05-4.37-73.02-5.15-88.01h70.04c-.77,14.99-4.36,74.97-5.15,88.01h0Z"/>
                  <path className="cls-1" d="M44.46,36.24c-1.47,0-2.67,1.19-2.67,2.67v67.09c0,1.47,1.19,2.67,2.67,2.67s2.67-1.19,2.67-2.67V38.9c0-1.47-1.19-2.67-2.67-2.67h0Z"/>
                  <path className="cls-1" d="M26.45,38.87c-.08-1.47-1.34-2.6-2.8-2.52-1.47.08-2.6,1.33-2.52,2.8l3.5,66.98c.07,1.42,1.25,2.53,2.66,2.53h.14c1.47-.08,2.6-1.33,2.52-2.8l-3.5-66.98h0Z"/>
                  <path className="cls-1" d="M65.29,36.35c-1.49-.08-2.72,1.05-2.8,2.52l-3.5,66.98c-.08,1.47,1.05,2.73,2.52,2.8h.14c1.41,0,2.59-1.1,2.66-2.53l3.5-66.98c.08-1.47-1.05-2.73-2.52-2.8h0Z"/>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div className="summary-step" id="summary2">
        {selectedCase && <img id="summaryImg2" src={selectedCase?.images[0]?.src} alt="Product Image"/>}
          <div className="summary-content">
            <p id="summaryTitle2">{selectedCase ? selectedCase.title : "Step 2: Please Select A Walli Case and Size"}</p>
            {selectedCaseVariant && <p id="summaryTitle2">{selectedCaseVariant.title}</p> }
            {selectedCase && <p id="summaryPrice2">{selectedCase?.variants[0].price}</p>}
          </div>
          <svg className="remove-button" onClick={() => {
            handleProductDelete(selectedCase)
          }} id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.93 120">
            <defs>
            </defs>
            <g id="Layer_2-2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1-2">
                <g>
                  <path className="cls-1" d="M82.28,9.12h-24.7v-2.46c0-3.67-2.95-6.66-6.58-6.66h-13.08c-3.63,0-6.58,2.99-6.58,6.66v2.46H6.65c-3.66,0-6.65,2.96-6.65,6.59v4.35c0,2.73,1.68,5.08,4.08,6.08.76,15.09,5.14,88.07,5.34,91.35.08,1.41,1.25,2.51,2.66,2.51h64.77c1.41,0,2.58-1.1,2.66-2.51.2-3.28,4.58-76.26,5.34-91.35,2.39-1,4.08-3.35,4.08-6.08v-4.35c0-3.63-2.98-6.59-6.65-6.59ZM36.68,6.66c0-.73.56-1.32,1.24-1.32h13.08c.69,0,1.24.59,1.24,1.32v2.46h-15.57v-2.46h0ZM5.33,15.71c0-.69.59-1.26,1.31-1.26h75.64c.72,0,1.31.56,1.31,1.26v4.35c0,.69-.59,1.26-1.31,1.26H6.65c-.72,0-1.31-.56-1.31-1.26v-4.35h-.01ZM74.34,114.67H14.59c-.78-13.05-4.37-73.02-5.15-88.01h70.04c-.77,14.99-4.36,74.97-5.15,88.01h0Z"/>
                  <path className="cls-1" d="M44.46,36.24c-1.47,0-2.67,1.19-2.67,2.67v67.09c0,1.47,1.19,2.67,2.67,2.67s2.67-1.19,2.67-2.67V38.9c0-1.47-1.19-2.67-2.67-2.67h0Z"/>
                  <path className="cls-1" d="M26.45,38.87c-.08-1.47-1.34-2.6-2.8-2.52-1.47.08-2.6,1.33-2.52,2.8l3.5,66.98c.07,1.42,1.25,2.53,2.66,2.53h.14c1.47-.08,2.6-1.33,2.52-2.8l-3.5-66.98h0Z"/>
                  <path className="cls-1" d="M65.29,36.35c-1.49-.08-2.72,1.05-2.8,2.52l-3.5,66.98c-.08,1.47,1.05,2.73,2.52,2.8h.14c1.41,0,2.59-1.1,2.66-2.53l3.5-66.98c.08-1.47-1.05-2.73-2.52-2.8h0Z"/>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      
      <div className="total-summary">
        <p id="totalPrice">Total: ${totalPrice}</p>
        <p id="discountPrice"></p>
      </div>
      <button className="add-to-cart-button" onClick={addToCart}>Buy Now</button>
    </div>
  </div>
</div>
  )
}

export default component((node, ctx) => {
  const element = <WalliBundle node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
